export default "__VITE_ASSET__e800cf16__"